import { useState, useEffect, useRef, useMemo } from "react";

// @mui material components
import Card from "@mui/material/Card";
import SuiTypography from "components/SuiTypography";
import SuiBox from "components/SuiBox";
import Carousel from "components/UpStyled/Carousel";
import SuiButton from "components/SuiButton";
import SuiInput from "components/SuiInput";

import Icon from "@mui/material/Icon";
import Tooltip from "@mui/material/Tooltip";
import toast from "react-hot-toast";

import EditIcon from "@mui/icons-material/Edit";
import ClearIcon from "@mui/icons-material/Clear";
import DoneIcon from "@mui/icons-material/Done";
import AddIcon from "@mui/icons-material/Add";
import DeleteIcon from "@mui/icons-material/Delete";
import IconButton from "@mui/material/IconButton";
import YouTubeIcon from "@mui/icons-material/YouTube";

import ArrowLeft from "components/Icon/ArrowLeft";
import ArrowRight from "components/Icon/ArrowRight";
import { color as colorList } from "utils/color";
import ReactPlayer from "react-player";
import { getBase64, dataURLtoFile, matchYoutubeUrl } from "utils/imageHelper";

import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import Dialog from "@mui/material/Dialog";

import Backdrop from "@mui/material/Backdrop";
import CircularProgress from "@mui/material/CircularProgress";
import MediaCard from "components/UpStyled/MediaCard";

import { nanoid } from "nanoid";
import { Upload } from "antd";
import api from "services/api";

let urlList = [];
const Gallery = ({ store, updateStore, editable = true }) => {
  const [editVisible, setEditVisible] = useState(false);
  const maxScrollWidth = useRef(0);
  const [currentIndex, setCurrentIndex] = useState(0);
  const [deleteConfirmVisible, setDeleteConfirmVisible] = useState(false);
  const [fileList, setFileList] = useState([]);
  const [deleteItem, setDeleteItem] = useState();
  const [uploading, setUploading] = useState(false);
  const [addLinkVisible, setAddLinkVisible] = useState(false);
  const [link, setLink] = useState();
  const [uploadFileList, setUploadFileList] = useState([]);

  const carousel = useRef(null);

  useEffect(() => {
    if (store && store.gallery) {
      setFileList(store.gallery);
    }
  }, [store, editVisible]);

  useEffect(() => {
    setFileList([...fileList, ...urlList]);
    urlList = [];
  }, [urlList.length]);

  const movePrev = () => {
    if (currentIndex > 0) {
      setCurrentIndex((prevState) => prevState - 1);
    }
  };

  const moveNext = () => {
    if (carousel.current && carousel.current.offsetWidth * currentIndex <= maxScrollWidth.current) {
      setCurrentIndex((prevState) => prevState + 1);
    }
  };

  useEffect(() => {
    if (carousel && carousel.current) {
      carousel.current.scrollLeft = carousel.current.offsetWidth * currentIndex;
    }
  }, [currentIndex]);

  const handleShowDeleteConfirmDialog = (item) => {
    setDeleteConfirmVisible(true);
    setDeleteItem(item);
  };

  const handleCancel = () => {
    setDeleteConfirmVisible(false);
  };

  const handleDelete = () => {
    const newList = fileList.filter((x) => x != deleteItem);
    setFileList(newList);
    setDeleteConfirmVisible(false);
  };

  const handleShowEdit = (e) => {
    setEditVisible(true);
    console.log(carousel);
  };

  const handleChange = async ({ file, fileList }) => {
    if (file.status == "uploading") {
      setUploadFileList(fileList);
    }
  };

  const idStr = uploadFileList.map((x) => x.uid).join(",");
  const memoizedList = useMemo(async () => {
    const urlList = [];

    for (let i = 0; i < uploadFileList.length; i++) {
      if (uploadFileList[i].type === "image/jpeg" || uploadFileList[i].type === "image/png") {
        const url = await getBase64(uploadFileList[i].originFileObj);
        urlList.push(url);
      } else if (uploadFileList[i].type === "video/mp4") {
        const blobURL = URL.createObjectURL(uploadFileList[i].originFileObj);
        urlList.push(blobURL);
      }
    }
    setFileList([...fileList, ...urlList]);
    return urlList;
  }, [idStr]);

  const beforeUpload = (file) => {
    if (file.type === "image/jpeg" || file.type === "image/png") {
      const isLt2M = file.size / 1024 / 1024 < 4;
      if (!isLt2M) {
        toast.error("Image must smaller than 4MB!");
        return false;
      }
    } else if (file.type === "video/mp4") {
      const isLt60M = file.size / 1024 / 1024 < 60;
      if (!isLt60M) {
        toast.error("Video must smaller than 60MB!");
        return false;
      }
    } else {
      toast.error("You can only upload JPG/PNG/MP4 file!");
    }

    return true;
  };

  const handleAddYoutubeLink = (e) => {
    e.preventDefault();
    if (matchYoutubeUrl(link)) {
      setFileList([...fileList, link]);
      setAddLinkVisible(false);
    } else {
      toast.error("Not a valid Youtube URL!");
    }
  };

  const handleUploadRequest = async ({ file }) => {};

  const handleSave = async (e) => {
    e.preventDefault();
    const uploadBlobList = [];
    try {
      const uploadList = fileList.filter((x) => x.startsWith("data")); // base64 url
      const uploadVideoList = fileList.filter((x) => x.startsWith("blob")); // blob url
      const existedList = fileList.filter((x) => !x.startsWith("data") && !x.startsWith("blob")); // url

      for (let i = 0; i < uploadList.length; i++) {
        const file = dataURLtoFile(uploadList[i], nanoid());

        uploadBlobList.push(file);
      }

      for (let i = 0; i < uploadVideoList.length; i++) {
        // convert blob to FileObj(MP4 video)
        const blob = await fetch(uploadVideoList[i]).then((r) => r.blob());
        const file = new File([blob], nanoid() + ".mp4");

        uploadBlobList.push(file);
      }
      setUploading(true);
      const uploadedImg = await api.uploads // upload images and video
        .create(uploadBlobList)
        .then((res) => {
          const uploaded = res.data.uploads.map(({ url }) => url);
          return uploaded;
        });

      await updateStore({ gallery: [...existedList, ...uploadedImg] });
      setUploading(false);
      toast.success("Update gallery successfully");
      setEditVisible(false);
    } catch (err) {
      setUploading(false);
      toast.error("Update gallery failed");
      console.log(err);
    }
  };

  return (
    <Card sx={{ px: 2 }}>
      <Backdrop sx={{ color: "#fff", zIndex: (theme) => 99999 }} open={uploading}>
        <CircularProgress color="inherit" />
      </Backdrop>
      <div className="m-4">
        <div className="my-2 flex justify-between ">
          <SuiTypography variant="h6" fontWeight="medium" textTransform="capitalize">
            Gallery
          </SuiTypography>
          {editable &&
            (editVisible ? (
              <div className="flex">
                <Tooltip title={"Cancel"} placement="top">
                  <IconButton aria-label="clear" size="small" onClick={() => setEditVisible(false)}>
                    <ClearIcon color="error" />
                  </IconButton>
                </Tooltip>
                <Tooltip title={"Save"} placement="top">
                  <IconButton aria-label="done" size="small" onClick={handleSave}>
                    <DoneIcon color="success" />
                  </IconButton>
                </Tooltip>
              </div>
            ) : (
              <Tooltip title={"Edit"} placement="top">
                <IconButton aria-label="edit" size="small" onClick={handleShowEdit}>
                  <EditIcon color="dark" />
                  <SuiTypography
                    variant="h6"
                    fontWeight="bold"
                    textTransform="uppercase"
                    sx={{ ml: 1, fontSize: 14 }}
                    className="xsmall:hidden small:inline"
                  >
                    EDIT
                  </SuiTypography>
                </IconButton>
              </Tooltip>
            ))}
        </div>
        {editVisible ? (
          <div className="carousel  mx-auto">
            <div className="relative overflow-hidden">
              <div className="flex justify-between absolute top left w-full h-full">
                <div
                  onClick={movePrev}
                  className="hover:cursor-pointer flex items-center w-10 h-full text-center disabled:cursor-not-allowed z-10 p-0 m-0 transition-all ease-in-out duration-300"
                >
                  <ArrowRight color={colorList["green"]} size={6} />
                  <span className="sr-only">Prev</span>
                </div>
                <div
                  onClick={moveNext}
                  className="hover:cursor-pointer flex items-center w-10 h-full text-center disabled:cursor-not-allowed z-10 p-0 m-0 transition-all ease-in-out duration-300"
                >
                  <ArrowLeft color={colorList["green"]} size={6} />
                  <span className="sr-only">Next</span>
                </div>
              </div>
              <div
                ref={carousel}
                className="carousel-container relative flex gap-4 overflow-hidden scroll-smooth snap-x snap-mandatory touch-pan-x z-0 mx-10"
              >
                {fileList.map((item, index) => {
                  if (item.startsWith("blob") || matchYoutubeUrl(item) || item.endsWith(".mp4")) {
                    return (
                      <div
                        key={index}
                        className="mx-4 my-1  grid justify-items-center carousel-item snap-start  relative  aspect-square block bg-origin-padding bg-left-top bg-cover bg-no-repeat z-0 "
                      >
                        <MediaCard src={item} type="video" />
                        <SuiButton
                          variant="text"
                          color="error"
                          onClick={() => handleShowDeleteConfirmDialog(item)}
                        >
                          <Icon>delete</Icon>
                          Delete
                        </SuiButton>
                      </div>
                    );
                  } else {
                    return (
                      <div key={index} className="mx-4 my-1  grid justify-items-center">
                        <MediaCard src={item} type="image" />

                        <SuiButton
                          variant="text"
                          color="error"
                          onClick={() => handleShowDeleteConfirmDialog(item)}
                        >
                          <Icon>delete</Icon>
                          Delete
                        </SuiButton>
                      </div>
                    );
                  }
                })}
              </div>
            </div>
            {fileList.length >= 8 ? null : (
              <div>
                <div className="flex items-center justify-center h-full px-2">
                  <div>
                    <Upload
                      showUploadList={false}
                      fileList={fileList}
                      maxCount={8}
                      beforeUpload={beforeUpload}
                      onChange={handleChange}
                      customRequest={(e) => handleUploadRequest(e)}
                      multiple
                    >
                      <div className="flex items-center hover:underline hover:cursor-pointer hover:decoration-2">
                        <AddIcon />
                        <div className="ml-2 ">Upload</div>
                      </div>
                    </Upload>
                  </div>
                  <div
                    className="hover:cursor-pointer hover:underline hover:decoration-2"
                    onClick={() => setAddLinkVisible(true)}
                  >
                    /Youtube Link
                  </div>
                </div>
              </div>
            )}
            {deleteConfirmVisible ? (
              <Dialog
                sx={{ "& .MuiDialog-paper": { width: "80%", maxHeight: 435 } }}
                maxWidth="xs"
                open={deleteConfirmVisible}
              >
                <DialogTitle>Delete image/video</DialogTitle>
                <DialogContent dividers>Are you sure you want to delete this?</DialogContent>
                <DialogActions>
                  <SuiButton autoFocus variant="gradient" color="light" onClick={handleCancel}>
                    Cancel
                  </SuiButton>
                  <SuiButton onClick={handleDelete} variant="gradient" color="error">
                    Delete
                  </SuiButton>
                </DialogActions>
              </Dialog>
            ) : null}

            {addLinkVisible ? (
              <Dialog
                sx={{ "& .MuiDialog-paper": { width: "80%", maxHeight: 435 } }}
                maxWidth="xs"
                open={addLinkVisible}
              >
                <DialogTitle>Add Youtube Link</DialogTitle>
                <DialogContent dividers>
                  <SuiBox key={"youtube_link"} py={1} pr={2}>
                    <SuiTypography variant="button" fontWeight="bold" textTransform="capitalize">
                      Youtube Link: &nbsp;
                    </SuiTypography>
                    <SuiTypography variant="button" fontWeight="regular" color="text">
                      <SuiInput
                        icon={{ direction: "left", component: <YouTubeIcon /> }}
                        placeholder="https://www.youtube.com/watch?v=xxxxxx"
                        required
                        onChange={(e) => setLink(e.target.value)}
                        name="youtube_link"
                      />
                    </SuiTypography>
                  </SuiBox>
                </DialogContent>
                <DialogActions>
                  <SuiButton
                    autoFocus
                    variant="gradient"
                    color="light"
                    onClick={() => setAddLinkVisible(false)}
                  >
                    Cancel
                  </SuiButton>
                  <SuiButton onClick={handleAddYoutubeLink} variant="gradient" color="dark">
                    Add
                  </SuiButton>
                </DialogActions>
              </Dialog>
            ) : null}
          </div>
        ) : store && store.gallery && store.gallery.length > 0 ? (
          <Carousel data={store.gallery} />
        ) : (
          <SuiTypography
            className="min-h-[200px] flex items-center"
            variant="h6"
            color="text"
            fontWeight="regular"
            textTransform="capitalize"
          >
            Please add images to your gallery
          </SuiTypography>
        )}
      </div>
    </Card>
  );
};

export default Gallery;
